import { Note } from "@contentful/f36-components";

const MiniNote = ({ text }: { text: string }) => {
  return (
    <Note variant="primary" >{`Conditional Fields - ${text}`}</Note>
  );
};

export default MiniNote;
